// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ui.dimmer[data-v-a17da80a] {\n    background-color: rgba(0,0,0,.25) !important;\n}\n", ""]);
// Exports
module.exports = exports;
